
import { CustomFieldFilterOptions } from './../../../../../helpers/enums/filters-and-searchs/CustomFieldFilterOptions';
import { CustomfieldService } from './../../../../../services/customfield.service';
import { Component, OnInit, ChangeDetectorRef, ViewChild, Renderer2 } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { DataTableDirective } from 'angular-datatables';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { ToasterService } from 'src/app/services/toater.service';
import { environment } from 'src/environments/environment';
import { Permission } from 'src/app/helpers/enums/roles/permission';
import { HasPermission } from 'src/app/helpers/has-permission.helper';
import { CustomFieldsDtColumnName } from 'src/app/helpers/constants/customFields/CustomFieldsDtColumnName';

declare const exportNav: any;
type SearchOption = { id: number, value: string, selected: boolean };

@Component({
  selector: 'app-custom-fields-list',
  templateUrl: './custom-fields-list.component.html',
  styleUrls: ['./custom-fields-list.component.css']
})
export class CustomFieldsListComponent implements OnInit {

  @BlockUI('container-blockui-manage') blockUI: NgBlockUI;
  @ViewChild(DataTableDirective, { static: false }) datatableElement: DataTableDirective;

  dtOptions: DataTables.Settings = {};
  dtInstance: DataTables.Api;
  rowIndex = 0;
  dtRendered = true;
  visibleColumns = [];
  isDtVisible = false;
  isDtInitialized = false;
  permissionType = Permission;
  hasPermissionType = HasPermission;
  users: any = [];
  isBulkActionDisabled = true;
  // for filters
  public filterOptionId: number = CustomFieldFilterOptions.None;
  private filterByItemId: string = '';
  private filterInOptionId: number = -1;
  private searchBy = -1;
  private searchFor: string = '';
  filterBy: any;
  formodel: string;
  frm: FormGroup;
  filterOptions: any;
  // capture filter open and close events
  filterNavStatus = false;

  constructor(private customFieldService: CustomfieldService,
    private tosterService: ToasterService,
    private renderer: Renderer2,
    private router: Router,
    public cdr: ChangeDetectorRef) { }

  get customFieldsFilterOptions(): any {
    return CustomFieldFilterOptions;
  }

  closeFilterEvent(event: any): void {
    this.filterNavStatus = event;
  }

  ngOnInit(): void {
    this.initDataTable();
  }

  ngAfterViewInit(): void {
    this.datatableElement.dtInstance.then((dtInstance: DataTables.Api) => {
      this.dtInstance = dtInstance;
      const header = dtInstance.columns().header();
      $(header).find('[action-type="select-unSelect-all"]')
        .off('change').on('change', (e: any) => {
          this.onSelectAllRow(e.target.checked);
        });
    });
  }
  //private methods
  private initDataTable(): void {
    const self = this;
    this.dtOptions = {
      dom: '<"top">rt<"bottom"lip><"clear">',
      serverSide: true,
      destroy: true,
      processing: true,
      language: {
        loadingRecords: '&nbsp;',
        processing: '<div class="block-ui-spinner"><div class="loader"></div></div>',
        paginate: {
          first: '<i class="fa fa-angle-double-left">',
          last: '<i class="fa fa-angle-double-right">',
          previous: '<i class="fa fa-angle-left">',
          next: '<i class="fa fa-angle-right">'
        }
      },
      displayStart: 0,
      paging: true,
      pagingType: 'full_numbers',
      pageLength: environment.paging.defaultPageSize,
      lengthMenu: environment.paging.lengthMenu,

      order: [[1, 'asc']],
      autoWidth: false,
      ajax: (dataTablesParameters: any, callback) => {
        self.blockUI.start();
        dataTablesParameters.filterOptionId = this.filterOptionId;
        dataTablesParameters.filterItemId = this.filterByItemId;
        dataTablesParameters.filterInOptionId = this.filterInOptionId ?? -1;
        dataTablesParameters.searchBy = this.searchBy;
        dataTablesParameters.searchFor = this.searchFor;
        self.customFieldService.query(dataTablesParameters)
          .subscribe(resp => {
            callback({
              recordsTotal: resp.recordsTotal,
              recordsFiltered: resp.recordsFiltered,
              data: resp.data
            });
            self.blockUI.stop();
          }, error => {
            self.tosterService.ProcessErrorResponse(error);
            self.blockUI.stop();
          }, () => { this.toggleControls(); });
      },
      columns: [
        {
          data: null,
          title: `<input type="checkbox" action-type="select-unSelect-all" />`,
          name: 'select',
          orderable: false,
          render: (data, type, row) => {
            return `<input type='checkbox' value = '${row.id}' action-type= "select-row"/>`;
          }
        },
        {
          data: CustomFieldsDtColumnName.Name,
          name: CustomFieldsDtColumnName.Name,
          title: 'Name',
          // render: (data, type, row) => {
          //   const html = HasPermission.validate([Permission.ViewClients]) && !row.isDeleted ?
          //     `<a class='link m-r-10' action-type='link-detail'>${row[CustomFieldsDtColumnName.Name]}</a>` : `<span>${row[CustomFieldsDtColumnName.Name]}</span>`;
          //   return html;
          // }
        },
        {
          data: CustomFieldsDtColumnName.Category,
          name: CustomFieldsDtColumnName.Category,
          title: 'Category',
          orderable: false
        },
        {
          data: CustomFieldsDtColumnName.Type,
          name: CustomFieldsDtColumnName.Type,
          title: 'Type',
          orderable: false
        },
        {
          data: 'name',
          title: (HasPermission.validate([Permission.DeleteClients]) || HasPermission.validate([Permission.EditClients])) ? 'Action' : '',
          name: 'action',
          orderable: false,
          render: (data, type, row) => {
            const disabled = '';
            const deleteButton = `<button  class='btn del-btn btn-lg btn-table' action-type="delete" ${disabled}>
            <i  class='align-middle rounded-circle bg-delete bg-delete-btn fas fa-trash-alt fa-1x p-2 text-danger'></i>
            </button>`;
            const undeleteButton = `<button  class='btn del-btn btn-lg btn-table' action-type="un-delete">
            <i  class='align-middle rounded-circle bg-delete bg-delete-btn fas fa-trash-restore-alt  fa-1x p-2 text-danger'></i>
            </button>`;
            const editButton = this.filterOptionId !== CustomFieldFilterOptions.DeletedCustomFields
              ? `<button  class='btn del-btn btn-lg btn-table' alt="undelete">
            <i action-type='edit' class='align-middle rounded-circle bg-delete bg-delete-btn fas fa-pencil-alt btn-edit fa-1x p-2'></i>
            </button>` : '';

            return `<div class='fa-edit'>${editButton} ${this.filterOptionId !== CustomFieldFilterOptions.DeletedCustomFields
              ? deleteButton : undeleteButton}
              </div>`;
          }
        },
      ],
      rowCallback: (row, data: any) => {
        const _row = $(row);

        _row.find('[action-type="edit"]')
          .off('click')
          .on('click', () => {
            self.edit(data.id);
          });
        _row.find('[action-type="delete"]')
          .off('click')
          .on('click', () => {
            self.delete([data.id]);
          });
        _row.find('[action-type="un-delete"]')
          .off('click')
          .on('click', () => {
            self.unDelete([data.id]);
          });
        _row.find('[action-type = "select-row"]')
          .off('click').on('click', (e: any) => {
            this.onSelectedOrUnselectRow(e);
          });
      },
      // Use this attribute to enable the responsive extension
      responsive: true,
    };
  }

  private toggleControls(): void {
    this.setSelectAllCheckbox();
    this.enableOrDisableDeleteButton();
  }

  private setSelectAllCheckbox(): void {
    const rows = this.dtInstance.rows().nodes();
    if (rows !== null) {
      const header = this.dtInstance.columns().header();
      const selectAllElement = $(header).find('[action-type="select-unSelect-all"]')[0] as any;
      const selelectedRows = [...rows.$('[action-type= "select-row"]')];
      selectAllElement.checked = selectAllElement != null && selelectedRows.length > 0
        && selelectedRows.every(row => row.classList.contains('checked'));
    }
  }

  private showColumns(): void {
    const visibleColumnsSelector = this.visibleColumns.map(item => `${item.toLowerCase()}:name`)
      .concat(['action:name', 'select:name']);
    const visibleIndexes = this.dtInstance.columns(visibleColumnsSelector).indexes().toArray();
    this.dtInstance.columns().every(function () {
      const colIndex = this.index();
      this.visible(visibleIndexes.includes(colIndex));
    });
    this.isDtVisible = true;
  }

  private reloadDataTable(): void {
    this.dtInstance.ajax.reload();
  }

  private getSelectedIds(): any[] {
    const customFieldIds = [];
    const rows = this.dtInstance.rows().nodes();
    [...rows.$('.checked')].forEach(item => customFieldIds.push($(item).val()));
    return customFieldIds;
  }

  private enableOrDisableDeleteButton(): void {
    const rows = this.dtInstance.rows().nodes();
    this.isBulkActionDisabled = [...rows.$('.checked')].length === 0;
  }

  onSelectedOrUnselectRow(event: any): void {
    if (event.target.checked) {
      this.renderer.addClass(event.target, 'checked');
    } else {
      this.renderer.removeClass(event.target, 'checked');
    }
    this.toggleControls();
  }
  // for filters
  applyFilter(filterData: any): void {
    this.searchBy = Number(filterData.searchBy);
    this.searchFor = filterData.searchFor;
    this.filterInOptionId = filterData.filterIn;
    const filterIdArr = filterData.filter?.split('_');
    if (filterIdArr && filterIdArr.length > 0) {
      this.filterOptionId = Number(filterIdArr[0]);
      if (filterIdArr.length > 1) {
        this.filterByItemId = filterIdArr[1];
      }
    }
    this.dtInstance.ajax.reload();
  }

  onResetFilters(): void {
    this.filterOptionId = CustomFieldFilterOptions.None;
    this.filterByItemId = '';
    this.filterInOptionId = -1;
    this.searchBy = -1;
    this.searchFor = '';
    this.dtInstance.ajax.reload();
  }


  permanentDelete(ids: number[]): void {
    if (!confirm('Are you sure you want to permanently delete selected Custom Fields(s)?')) {
      return;
    }
    this.blockUI.start();
    this.customFieldService.permanentDeleteCustomFields(ids).subscribe(() => {
      this.reloadDataTable();
      this.tosterService.success('Custom Field(s) has been permanent deleted successfully.');
      this.blockUI.stop();
    }, error => {
      this.tosterService.ProcessErrorResponse(error);
      this.blockUI.stop();
    });
  }

  delete(ids: number[]): void {
    if (!confirm('Are you sure you want to delete selected Custom Fields(s)?')) {
      return;
    }
    this.blockUI.start();
    this.customFieldService.deleteCustomFields(ids).subscribe(() => {
      this.reloadDataTable();
      this.tosterService.success('Custom Field(s) has been deleted successfully.');
      this.blockUI.stop();
    }, error => {
      this.tosterService.ProcessErrorResponse(error);
      this.blockUI.stop();
    });
  }

  unDelete(ids: number[]): void {
    if (!confirm('Are you sure you want to undelete selected custom field(s)?')) {
      return;
    }
    this.blockUI.start();
    this.customFieldService.undeleteCustomFields(ids).subscribe(() => {
      this.reloadDataTable();
      this.tosterService.success('Custom Field(s) has been undeleted successfully.');
      this.blockUI.stop();
    }, error => {
      this.tosterService.ProcessErrorResponse(error);
      this.blockUI.stop();
    });
  }

  onSelectAllRow(isChecked: boolean): void {
    const rows = this.dtInstance.rows().nodes();
    const checkBoxes = [...rows.$('[action-type= "select-row"]')];
    if (isChecked) {
      checkBoxes.forEach(row => {
        this.renderer.addClass(row, 'checked');
        (row as HTMLInputElement).checked = true;
      });
    } else {
      checkBoxes.forEach(row => {
        this.renderer.removeClass(row, 'checked');
        (row as HTMLInputElement).checked = false;
      });
    }
    this.enableOrDisableDeleteButton();
  }

  edit(id: number): void {
    this.router.navigate(['/setting/global/edit-custom-field', id]);
  }

  onBulkDelete(): void {
    this.delete(this.getSelectedIds());
  }

  onBulkUnDelete(): void {
    this.unDelete(this.getSelectedIds());
  }
  onBulkPermanentDelete(): void {
    this.permanentDelete(this.getSelectedIds());
  }



}
